// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@babel/polyfill'

// 引入全局reset
import './common/css/reset.css';
import $ from 'jquery'
import './common/js/jquery.SuperSlide.2.1.1';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueSeamlessScroll from 'vue-seamless-scroll'
import tip from './components/tip/tip'  //提示框全局引用

Vue.use(ElementUI);
Vue.use(vueSeamlessScroll);

Vue.component('tip', tip);  //全局注册提示框
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js